// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';

type PageData = {
    pageSidebar?: {
        isPowerUserPanel: boolean;
    }
    [key: string]: unknown;
};

const pageData = makeVar<PageData>({});

export const usePageData = () => useReactiveVar(pageData);

export default pageData;
